import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full px-4 py-12 md:py-20 max-w-3xl mx-auto text-center" data-id="element-16">
      {/* Badge */}
      <FadeIn data-id="element-17">
        <div className="inline-block bg-[#7B9E6B]/10 text-[#7B9E6B] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-18">
          14-Day Balance Plan for Women 65+
        </div>
      </FadeIn>

      {/* Headline & Subtitle */}
      <FadeIn delay={0.1} data-id="element-19">
        <h1 className="text-4xl md:text-6xl font-bold text-[#2D2A26] mb-6 leading-tight font-serif" data-id="element-20">
          10 Minutes a Day to Feel Steadier on Your Feet
        </h1>
        <p className="text-xl md:text-2xl text-[#2D2A26]/80 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-21">
          A chair-supported plan you can do at home — no gym, no long workouts,
          no fear.
        </p>
      </FadeIn>

      {/* Visual Chips */}
      <FadeIn delay={0.2} data-id="element-22">
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-10" data-id="element-23">
          {['Chair-Supported', '10 Min/Day', 'No Gym Needed'].map(text => <div key={text} className="flex items-center bg-white border border-[#7B9E6B]/20 px-4 py-2 rounded-full shadow-sm" data-id="element-24">
              <div className="bg-[#7B9E6B] rounded-full p-0.5 mr-2" data-id="element-25">
                <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-26" />
              </div>
              <span className="text-[#2D2A26] font-medium text-sm md:text-base" data-id="element-27">
                {text}
              </span>
            </div>)}
        </div>
      </FadeIn>

      {/* CTA Area */}
      <FadeIn delay={0.3} className="mb-16" data-id="element-28">
        <div className="flex flex-col items-center" data-id="element-29">
          <Button showArrow className="mb-3 transform hover:scale-105 transition-transform duration-300" onClick={() => document.getElementById('purchase')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })} data-id="element-30">
            Get Started Today — $6.39
          </Button>
          <p className="text-sm text-[#2D2A26]/60 font-medium" data-id="element-31">
            <span className="line-through opacity-60 mr-2" data-id="element-32">$19</span>
            <span className="text-[#7B9E6B]" data-id="element-33">Instant Access</span>
          </p>
        </div>
      </FadeIn>

      {/* Product Image */}
      <FadeIn delay={0.4} className="mb-16" data-id="element-34">
        <div className="relative rounded-xl overflow-hidden shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-700 max-w-md mx-auto bg-[#F5F2EB] p-2 border border-[#2D2A26]/5" data-id="element-35">
          <div className="absolute -top-1 -right-1 w-3 h-3 bg-[#FF5A5F] rounded-full opacity-60" data-id="element-36" />
          <img src="https://cdn.magicpatterns.com/uploads/bfCeVu19ugPMZHBCFMDuPZ/heylloyd-image-1770703284372.png" alt="No-Fall Confidence Guide on a tablet in a warm kitchen setting" className="w-full h-auto rounded-lg" data-id="element-37" />
        </div>
      </FadeIn>

      {/* Emotional Hook */}
      <FadeIn delay={0.5} data-id="element-38">
        <div className="max-w-2xl mx-auto relative" data-id="element-39">
          <div className="absolute -left-4 top-0 w-1 h-full bg-gradient-to-b from-[#FF5A5F]/40 to-transparent rounded-full hidden md:block" data-id="element-40" />
          <p className="text-xl md:text-2xl font-serif italic text-[#2D2A26] leading-relaxed" data-id="element-41">
            "You're not fragile — you're cautious. This plan helps your body
            relearn steadiness, one safe step at a time."
          </p>
        </div>
      </FadeIn>
    </section>;
}